export default requester => {
    return {
        /**
         * Gets user's social accounts
         *
         * @param {object} handle
         **/
        social (handle = {}) {
            return requester.get(`/users/${handle}/social`);
        },
        
        /**
         * Shadow user
         *
         * @param {object} handle
         **/
        shadow (params) {
            return requester.post(`account/shadow`, params);
        },

        /**
         * Gets user's profile accounts
         *
         * @param {object} handle
         **/
        profile (handle = {}) {
            return requester.get(`/users/${handle}/profile`);
        },

        search (params, config = {}) {
            // TODO: it will change to users instead of mentions in the future.
            return requester.get(`/search/users`, { ...config, params });
        },

        /**
         * Get user's detailed info by handle.
         */
        detailed(handle, params = {}) {
            return requester.get(`/users/${handle}/detailed`, { params });
        },

        /**
         * Check handle availability.
         */
        handlers(params = {}) {
            return requester.get(`/users/handlers`, { params });
        },
    };
}
